import * as TYPES from './care-team-actiontypes';
import { getCareTeam, getUserProfileImageUrl } from './care-team-api';

const careTeamMemberFields = [
  'careTeamId',
  'patientId',
  'careProviderId',
  'firstName',
  'lastName',
  'publicEmail',
  'address1',
  'address2',
  'address3',
  'city',
  'state',
  'country',
  'zipCode',
  'publicPhone',
  'publicPhoneExt',
  'fax',
  'institution',
  'careProviderTitleValue',
  'careProviderTitle',
  'suffix',
  'photoFilename',
  'photoThumbnailFilename',
  'preferredSecureMessageIfSystemId',
  'secureMessageRecipientForPatient',
];

export const careTeamLoadSuccess = (response) => {
  const members = response.map((member) => {
    const stateMember = {};
    careTeamMemberFields.forEach((field) => {
      stateMember[field] = member[field];
    });

    if (member.photoThumbnailFilename) {
      stateMember.userProfileImageUrl = getUserProfileImageUrl(member.photoThumbnailFilename);
    }

    return stateMember;
  });

  const state = {
    members,
  };

  return {
    type: TYPES.CARE_TEAM_LOADED_SUCCESS,
    state,
  };
};

export const careTeamLoadFailed = () => ({
  type: TYPES.CARE_TEAM_LOADED_FAILURE,
});

export const loadCareTeam = (patientId) => (dispatch) =>
  getCareTeam(patientId)
    .then(
      (response) =>
        dispatch(careTeamLoadSuccess(response.data)),
      () => dispatch(careTeamLoadFailed())
    );
